import styled from 'styled-components'

export const Container = styled.div`
	position: fixed;
	left: 0;
	right: 0;
	bottom: 0;
	display: flex;
	flex-direction: column-reverse;
	align-items: center;
	z-index: 11;

	pointer-events: none;
`
